__turbopack_context__.v({
  "avatarCard": "AI-avatars-module__N93mYG__avatarCard",
  "avatarGrid": "AI-avatars-module__N93mYG__avatarGrid",
  "avatarTypeSelect": "AI-avatars-module__N93mYG__avatarTypeSelect",
  "botNameInput": "AI-avatars-module__N93mYG__botNameInput",
  "buttonGroup": "AI-avatars-module__N93mYG__buttonGroup",
  "configTitle": "AI-avatars-module__N93mYG__configTitle",
  "configWrapper": "AI-avatars-module__N93mYG__configWrapper",
  "contactUsText": "AI-avatars-module__N93mYG__contactUsText",
  "container": "AI-avatars-module__N93mYG__container",
  "createButton": "AI-avatars-module__N93mYG__createButton",
  "formRow": "AI-avatars-module__N93mYG__formRow",
  "formSection": "AI-avatars-module__N93mYG__formSection",
  "inputWrapper": "AI-avatars-module__N93mYG__inputWrapper",
  "modelOption": "AI-avatars-module__N93mYG__modelOption",
  "presetSelect": "AI-avatars-module__N93mYG__presetSelect",
  "providerSection": "AI-avatars-module__N93mYG__providerSection",
  "root": "AI-avatars-module__N93mYG__root",
  "sectionTitle": "AI-avatars-module__N93mYG__sectionTitle",
  "selectWrapper": "AI-avatars-module__N93mYG__selectWrapper",
  "selected": "AI-avatars-module__N93mYG__selected",
  "textArea": "AI-avatars-module__N93mYG__textArea",
  "textAreaSection": "AI-avatars-module__N93mYG__textAreaSection",
  "title": "AI-avatars-module__N93mYG__title",
  "topSection": "AI-avatars-module__N93mYG__topSection",
  "typeSelect": "AI-avatars-module__N93mYG__typeSelect",
});
